export class Payment {
  token: String;
  amount: number;
  invoiceNumber: String;
  currency: String;
  clientMail: String;
  status: String;
  description?: String;
  metadata?: any;
}
